import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const StarsIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      d="M4 0C4 2.66667 2.66667 4 0 4C2.66667 4 4 5.33333 4 8C4 5.33333 5.33333 4 8 4C5.33333 4 4 2.66667 4 0Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M3 12C3 13.3333 2.33333 14 1 14C2.33333 14 3 14.6667 3 16C3 14.6667 3.66667 14 5 14C3.66667 14 3 13.3333 3 12Z"
      stroke="currentColor"
    />
    <path
      d="M10.5 5C10.5 8.66667 8.66667 10.5 5 10.5C8.66667 10.5 10.5 12.3333 10.5 16C10.5 12.3333 12.3333 10.5 16 10.5C12.3333 10.5 10.5 8.66667 10.5 5Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
));
